import Image from "next/image";

export const toCockpitImagePath = (path: string) => {
  if (!path) return path;
  // When we are on the server side, use the getcockpit endpoint, else use public

  if (path.endsWith(".svg")) {
    // Always use public endpoint because of unoptimized display variant
    const url = new URL(path, process.env.NEXT_PUBLIC_GETCOCKPIT_ENDPOINT);
    return url.href;
  }

  const url = new URL(
    path,
    typeof window !== "undefined"
      ? process.env.NEXT_PUBLIC_GETCOCKPIT_ENDPOINT
      : process.env?.NEXT_PUBLIC_GETCOCKPIT_ENDPOINT ||
        process.env?.GETCOCKPIT_ENDPOINT,
  );
  return url.href;
};

export function CockpitImage({
  path,
  width,
  height,
  description,
  altText,
}: {
  path: string;
  width: number;
  height: number;
  description: string;
  altText: string;
}) {
  const src = toCockpitImagePath(path);
  if (!src) return null;
  return (
    <Image
      src={src}
      alt={description || altText}
      width={width}
      height={height}
      unoptimized={src?.endsWith(".svg")}
    />
  );
}
